import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import LandingPage from "@/components/LandingPage";
import EmergencyPage from "@/components/EmergencyPage";
import InfoPage from "@/components/pages/InfoPage";
import ContactPage from "@/components/pages/ContactPage";
import SupporterPage from "@/components/supporter/SupporterPage";
import TrailPage from "@/components/pages/TrailPage";
import GetAppPage from "@/components/pages/GetAppPage";
import TrollPeek from "@/components/landing/TrollPeek";
import HostsPage from "@/components/hosts/HostsPage";
import SoundToggle from "@/components/SoundToggle";
import SOSButton from "@/components/SOSButton";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider, useLang } from "@/i18n/LanguageContext";

const LocalizedToaster = () => {
  const { t } = useLang();
  return (
    <Toaster
      position="top-center"
      offset="104px"
      containerAriaLabel={t.a11y.notifications}
      toastOptions={{
        classNames: {
          toast: "!bg-parchment !text-ink !border-line !rounded-[16px] !font-body",
          description: "!text-ink-muted",
        },
      }}
    />
  );
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!window.location.hash) window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const INFO_PAGES = ["about", "press", "privacy", "terms"];

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <SOSButton />
          <SoundToggle />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/emergency" element={<EmergencyPage />} />
            {INFO_PAGES.map((p) => (
              <Route key={p} path={`/${p}`} element={<InfoPage page={p} />} />
            ))}
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/supporter" element={<SupporterPage />} />
            <Route path="/trails/:key" element={<TrailPage />} />
            <Route path="/get-app" element={<GetAppPage />} />
            <Route path="/hosts" element={<HostsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <LocalizedToaster />
          <TrollPeek />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
